import { useMatches, useNavigate, useParams } from 'react-router-dom';
import { Subtitle2Text } from '@/utils/global-fonts';
import Styled from './breadcrumb-style';

/**
 *
 * BreadCrumb component displays a navigational breadcrumb with a dynamic title based on the active side navigation.
 * Includes a back button to navigate to the previous page.
 * @returns {JSX.Element}
 */
const BreadCrumb = () => {
  const matches = useMatches();
  const navigate = useNavigate();
  const { ...params } = useParams();

  return (
    <Styled.Container>
      <Styled.BreadcrumbItems>
        <Styled.BackIcon
          fontSize="20px"
          mr="16px"
          onClick={() => navigate(-1)}
        />
        {matches?.map((match, index) => (
          <Subtitle2Text
            key={`component____breadcrumb____${index + 1}`}
            primary={index < matches.length - 1}
          >
            {match?.handle?.parent ? (
              <>
                {match?.handle?.parent(params)}
                {index < matches.length - 1 && <Styled.ChevronIcon />}
              </>
            ) : null}
            {match?.handle?.crumb ? (
              <>
                {match?.handle?.crumb()}
                {index < matches.length - 1 && <Styled.ChevronIcon />}
              </>
            ) : null}
          </Subtitle2Text>
        ))}
      </Styled.BreadcrumbItems>
      <Styled.ButtonsContainer id="breadcrumb-buttons" />
    </Styled.Container>
  );
};

export default BreadCrumb;
